export default __webpack_public_path__ + "static/Klasse_Steira_WR-73cfc75629d4d0e952cc08b0869a1b05.jpg";